
import React from 'react';
import CSVUploader from '../components/CSVUploader';

const CSVUploaderPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-sm border-b border-gray-100 shadow-sm">
        <div className="container mx-auto px-4 md:px-6 py-3 flex justify-between items-center">
          <h1 className="text-xl font-bold">CSV Data Uploader</h1>
          <a href="/" className="text-blue-500 hover:text-blue-700 transition-colors">
            Back to Home
          </a>
        </div>
      </header>
      
      <main className="container mx-auto px-4 md:px-6 py-8">
        <CSVUploader />
      </main>
    </div>
  );
};

export default CSVUploaderPage;
